module.exports = __webpack_public_path__ + "static/media/wyloguj.4aa56f7c.svg";